import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { GALLERY, IMG } from "../lib/content";
import { EASE } from "./Reveal";

export const GalleryGrid = () => (
  <div data-testid="gallery-grid" className="columns-1 sm:columns-2 lg:columns-3 gap-4 [&>*]:mb-4">
    {GALLERY.map((g, i) => (
      <motion.div
        key={i}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay: (i % 3) * 0.08, ease: EASE }}
        className="group relative overflow-hidden break-inside-avoid cursor-pointer"
      >
        <img
          src={IMG[g.img]}
          alt={g.label}
          loading="lazy"
          className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${
            i % 4 === 0 ? "h-[520px]" : i % 3 === 0 ? "h-[340px]" : "h-[420px]"
          }`}
        />
        <div className="absolute inset-0 bg-dst-red/0 group-hover:bg-dst-red/70 transition-colors duration-500" />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          <span className="w-14 h-14 grid place-items-center border-2 border-white text-white rounded-full">
            <Plus size={24} />
          </span>
        </div>
        <div className="absolute bottom-0 left-0 p-5">
          <span className="font-oswald uppercase tracking-wider text-white text-lg drop-shadow-lg">{g.label}</span>
        </div>
      </motion.div>
    ))}
  </div>
);
